import moment from 'moment';
import Pikaday from 'pikaday';
import { $win, $doc } from './utils';

const $bm = $('.js-bm');
const $body = $('body');
const format = 'MM/DD/YYYY';
const formatText = 'DD  MMMM  YYYY';

let manualUpdate = false

const toggleManualUpdate = () => {
	manualUpdate = !manualUpdate
}

const toggleHeaderClass = () => {
	if ($('.bm--hero').length) {
		$('.header').addClass('has-bm-hero')
	} else {
		$('.header').removeClass('has-bm-hero')
	}
}

const toggleBmHeader = () => {
	const $bmHeader = $('.bm--header');
	const $trigger = $('.js-toggle-bm-header')

	$trigger.on('click', function(e) {
		e.preventDefault();

		$trigger.toggleClass('active');
		$bmHeader.toggleClass('active');
		$body.toggleClass('bm-open');
	})
}

const togglePopups = () => {
	const $triggers = $('.js-toggle-popup', $bm);

	$triggers.on('click', function(e) {
		e.preventDefault();

		const $this = $(this);
		const $target = $($this.data('target'));

		$target.addClass('active');
		$body.addClass('bm-modal-open');

		$target.closest('.js-bm-col').addClass('active')
	})
}

const initDatepickers = () => {
	const $datepickers = $('.js-bm-datepickers', $bm);

	$datepickers.each((index, el) => {
		const $el = $(el);
		const container = el.querySelector('.js-bm-holder');
		const fieldStart = el.querySelector('.js-bm-start-field');
		const fieldEnd = el.querySelector('.js-bm-end-field');
		const $popup = $el.find('.js-datepicker-popup');
		let minDate = new Date();
		let startDate, endDate;
		let isFirstDatepickerChange = false;
		const $focusTarget = $bm.find('.focus-target');
		let isStartDateSelected = false;

		const today = moment().format(formatText);
		const tomorrow = moment().add(1, 'days').format(formatText);

		$(fieldStart).val(today);
		$(fieldEnd).val(tomorrow);

		const options = {
			format: formatText,
			bound: false,
			firstDay: 1,
			todayHighlight: true,
			numberOfMonths: 1,
			keyboardInput: false,
			theme: 'pikaday-bm',
			container
		}

		const updateStartDate = () => {
			isFirstDatepickerChange = true
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add(1,'days')._d;
			endPicker.setMinDate(endDate);
			// endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			startPicker.hide();
			endPicker.show();

			$(fieldEnd).closest('.js-bm-col').addClass('active');
			$(fieldStart).closest('.js-bm-col').removeClass('active');

			setTimeout(() => {
				isFirstDatepickerChange = false
			}, 50);
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);

			if (isFirstDatepickerChange) {
				endPicker.hide();
				startPicker.show();
			} else {
				closeDatepicker()
			}

			$(fieldStart).closest('.js-bm-col').addClass('active');
			$(fieldEnd).closest('.js-bm-col').removeClass('active');
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			minDate,
			...options,
			onSelect: function() {
				startDate = this.getDate();

				updateStartDate();

				setTimeout(function() {
					const nextDate = moment(startDate).add(1, 'days');
					const selectedMonth = nextDate.month();
					const selectedYear = nextDate.year();


					const date = moment(startDate).add(1, 'days');
					let currentMonth = nextDate.month();
					let currentYear = nextDate.year();

					endPicker.gotoMonth(currentMonth);
					endPicker.gotoYear(currentYear);
				}, 10);

				isStartDateSelected = true;

				$(fieldEnd).focus();
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			...options,
			onSelect: function() {
				endDate = this.getDate();
				updateEndDate();

				$(fieldEnd).closest('.bm').find('.bm__btn').focus();
			},
			onDraw: function() {
				if (isStartDateSelected) {
					initHighlight();
				}
			}
		});

		function initHighlight() {
			const $buttons = $popup.find('.pika-button');
			$buttons.on('mouseenter', function() {
				const $hoverButton = $(this);
				const hoverButtonDate = moment(`${$hoverButton.data('pika-day')}/${$hoverButton.data('pika-month')}/${$hoverButton.data('pika-year')}`, 'DD/MM/YYYY')

				$buttons.each(function() {
					const $currentButton = $(this);
					const $parent = $currentButton.parent();
					const currentButtonDate = moment(`${$currentButton.data('pika-day')}/${$currentButton.data('pika-month')}/${$currentButton.data('pika-year')}`, 'DD/MM/YYYY')

					if ($parent.hasClass('is-startrange')) {
						$parent.addClass('is-fake-start-range');
					}

					if ($parent.hasClass('is-disabled') || $parent.hasClass('is-today')) {
						return;
					}

					$parent.removeClass('is-inrange is-endrange is-startrange is-fake-range');

					if (currentButtonDate.isBefore(hoverButtonDate)) {
						$parent.addClass('is-inrange is-fake-range');
					}
				});

				$hoverButton.parent().addClass('is-selected is-endrange is-fake-end-range');
			});
		}

		startPicker.setDate(moment(today).format(formatText));
		endPicker.setDate(moment(tomorrow).format(formatText));

		$(fieldStart).on('focusin', function() {
			if (!manualUpdate) {
				endPicker.hide();
				startPicker.show();
				$popup.addClass('active');

				$body.addClass('bm-datepicker-open');
				$(fieldStart).closest('.js-bm-col').addClass('active');
				$(fieldEnd).closest('.js-bm-col').removeClass('active');
			}
		});

		$(fieldEnd).on('focusin', function() {
			if (!manualUpdate) {
				endPicker.show();
				startPicker.hide();
				$popup.addClass('active');

				$body.addClass('bm-datepicker-open');
				$(fieldEnd).closest('.js-bm-col').addClass('active');
				$(fieldStart).closest('.js-bm-col').removeClass('active');
			}
		})

		$(fieldStart).on('change', function() {
			if ( manualUpdate ) {
				startDate = moment($(this).val(), formatText).set({year: moment().format('YYYY')})._d;
				updateStartDate();

				const nextDate = moment(startDate).add(1, 'days');
				const selectedMonth = nextDate.month();
				const selectedYear = nextDate.year();

				endPicker.setEndRange(nextDate._d);

				endPicker.gotoMonth(selectedMonth);
				endPicker.gotoYear(selectedYear);
			}
		});

		$(fieldEnd).on('change', function() {
			if ( manualUpdate ) {
				const val = $(this).val();

				endDate = moment(val, formatText).set({year: moment(val, format).format('YYYY')})._d;
				updateEndDate();
			}
		});

		function closeDatepicker() {
			endPicker.hide();
			startPicker.hide();
			$popup.removeClass('active');

			$body.removeClass('bm-datepicker-open');
			$(fieldEnd).closest('.js-bm-col').removeClass('active');
			$(fieldStart).closest('.js-bm-col').removeClass('active');

			$focusTarget.focus();
		}
	});
}

const handleClosePopups = () => {
	const $popup = $('.js-bm-popup');

	$doc.on('click', function(event) {
		const $target = $(event.target);

		// Handle datepickers popup close
		if (
			!$target.parents('.js-bm-datepickers').length && !$target.parents('.js-datepicker-popup').length
		) {
			$('.js-bm-datepickers').removeClass('active');
			$('.js-bm-datepickers').find('.active').removeClass('active');

			$body.removeClass('bm-datepicker-open');
		}

		// Handle rest popups close
		if (
			!$target.parents('.js-bm-popup').length && !$target.parents('.js-toggle-popup').length
		) {
			$popup.removeClass('active');
			$popup.closest('.js-bm-col').removeClass('active')
			$body.removeClass('bm-modal-open');
		}

		// Handle close btn click
		if ($target.hasClass('js-close-popup')) {
			$popup.removeClass('active');
			$target.closest('.js-datepicker-popup').removeClass('active');
			$popup.closest('.js-bm-col').removeClass('active')
			$body.removeClass('bm-datepicker-open');
			$body.removeClass('bm-modal-open');
		}
	})
}

const handlePlural = () => {
	$('.js-check-plural').each(function() {
		const $this = $(this);
		const single = $this.data('single');
		const multi = $this.data('multi');
		const $target = $($this.data('target'));
		const number = Number($this.text());

		if ( number <= 1 ) {
			$target.text(single);
		} else {
			$target.text(multi);
		}
	});
};

const handleTextFields = (selector) => {
	$doc.on('change', selector, function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.text($this.val());

		handlePlural();
	});
}

const handleLocationChange = () => {
	const $trigger = $('.js-bm-location-trigger');

	$trigger.on('click', function(e) {
		e.preventDefault();

		const $this = $(this);
		const $target = $($this.data('value-target'));
		const value = $this.data('value')

		$target.val(value)
		$target.data('url', $this.data('url'));
		$target.trigger('change')
	})
}

const handlePopupsPosition = () => {
	const $bmBar = $('.bm:not(.bm--header)')

	if ($bmBar.length) {
		const bmTop = $bmBar.offset().top

		$win.on('load scroll', function(e) {
			let st = $win.scrollTop()

			// Show popups at bottom in bm bar
			$bmBar.toggleClass('bm--bottom', st > bmTop - 600)
		})
	}
}

function syncFields($firstContainer, $secondContainer) {
	// Update Inputs
	$firstContainer.find('input').on('change', function() {
		updateTwin($secondContainer, $(this).attr('name'), $(this).val());
	});

	$secondContainer.find('input').on('change', function() {
		updateTwin($firstContainer, $(this).attr('name'), $(this).val());
	});

	//Update Selects
	$firstContainer.find('select').on('change', function() {
		updateTwin($secondContainer, $(this).attr('name'), $(this).val(), true);
	});

	$secondContainer.find('select').on('change', function() {
		updateTwin($firstContainer, $(this).attr('name'), $(this).val(), true);
	});
}

function updateTwin($container, name, val, isSelect = false) {
	const $field = $container.find(`[name="${name}"]`);

	if (!manualUpdate) {
		$field.val(val);

		if ( $field.hasClass('js-bm-start-field') || $field.hasClass('js-bm-end-field') ) {
			toggleManualUpdate()

			$field.trigger('change');

			setTimeout(() => {
				toggleManualUpdate();
			}, 50)
		}
	}
}

export default function bookingMaskUI(args) {
	handleClosePopups();
	togglePopups();
	toggleHeaderClass();

	toggleBmHeader();

	initDatepickers();

	handleTextFields('.js-qty-field');

	handlePlural();

	handleLocationChange();

	handlePopupsPosition();

	syncFields($('.bm:not(.bm--header)'), $('.bm--header'))
}
